import React from "react";
import { Helmet } from "react-helmet";
import {
  FaHeartbeat,
  FaMoneyBillWave,
  FaSeedling,
  FaChalkboardTeacher,
} from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

import heroImage from "../images/blue_home.jpg";
import aboutImage from "../images/about-us.jpg";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";

import ClientsSection from "./Components/ClientsSection";
import StatsSection from "./Components/StatsSection";
import WhatsAppButton from "./Components/WhatsAppButton";

import hero1 from "../images/blue_home.jpg";
import hero2 from "../images/white_home.jpg";
import hero3 from "../images/home_third.jpg";
import { API_URL } from "./Config/Env";


const heroImages = [hero1, hero2, hero3];

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await fetch(`${API_URL}/track_visit/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            page: "home",
            timestamp: new Date().toISOString(),
          }),
        });
      } catch (error) {
        console.error("Error tracking visit:", error);
      }
    };

    trackVisit();
  }, []);

  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>
          NEXINDI TECH | Web Development, Mobile Apps & Digital Solutions in
          Kenya
        </title>

        <meta
          name="description"
          content="NEXINDI TECH is a leading technology company in Kenya specializing in web development, mobile applications, business systems, software solutions, and digital transformation services across Africa."
        />

        <meta
          name="keywords"
          content="NEXINDI TECH, web development Kenya, mobile app development Kenya, software company Kenya, digital solutions Africa, business systems, best software development company Kenya, React development, Django development, tech company kenya, tech company Meru, Nairobi software developers"
        />

        <meta name="author" content="NEXINDI TECH" />

        <meta
          property="og:title"
          content="NEXINDI TECH | Empowering Africa Through Technology"
        />

        <meta
          property="og:description"
          content="We build innovative web applications, mobile apps, business systems, and digital platforms for businesses and institutions across Africa."
        />

        <meta property="og:type" content="website" />

        <meta property="og:image" content={heroImage} />

        <meta property="og:url" content="https://nexinditechcompany.online/" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="NEXINDI TECH | Technology Solutions Company"
        />

        <meta
          name="twitter:description"
          content="Innovative digital solutions in Health, Finance, Agriculture, and Education."
        />

        <meta name="twitter:image" content={heroImage} />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://nexinditechcompany.online/" />
      </Helmet>

      <div className="font-sans text-gray-800">
        {/* Hero Section */}
<section
  className="relative min-h-screen flex items-center overflow-hidden text-white"
  style={{
    backgroundImage: `url(${heroImages[currentSlide]})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Premium dark overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-blue-950/80 to-slate-900/50"></div>

  {/* Secondary depth overlay */}
  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-slate-950/20"></div>

  {/* Decorative glow */}
  <div className="absolute -top-32 -left-32 w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[140px]"></div>

  <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-cyan-400/10 rounded-full blur-[140px]"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
    <div className="max-w-4xl">

      {/* Badge */}
      <div className="inline-flex items-center mt-10 gap-2 px-4 py-2 mb-7 rounded-full border border-white/20 bg-white/10 backdrop-blur-md text-sm font-medium">
        <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse"></span>
        Building technology for Africa
      </div>

      {/* Main headline */}
      <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-[1.05] tracking-tight mb-7">
        Technology that
        <span className="block bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-300 bg-clip-text text-transparent">
          moves Africa forward.
        </span>
      </h1>

      {/* Description */}
      <p className="text-lg md:text-xl lg:text-2xl text-slate-200 leading-relaxed max-w-3xl mb-10">
        Nexindi Tech builds modern digital solutions that help businesses,
        organizations, and communities grow across
        <span className="text-white font-medium">
          {" "}Health, Finance, Agriculture, and Education.
        </span>
      </p>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">

        <a href="/services">
          <button className="group inline-flex items-center justify-center gap-3 bg-white text-slate-900 px-7 py-4 rounded-xl font-semibold text-base hover:bg-blue-50 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-500/20">
            Explore Our Solutions

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="transition-transform duration-300 group-hover:translate-x-1"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </button>
        </a>

        <a href="/contact">
          <button className="inline-flex items-center justify-center px-7 py-4 rounded-xl font-semibold text-base border border-white/30 bg-white/10 backdrop-blur-md hover:bg-white/20 transition-all duration-300">
            Talk to Our Team
          </button>
        </a>

      </div>

      {/* Bottom credibility text */}
      <div className="flex flex-wrap items-center gap-x-8 gap-y-4 mt-14 text-sm text-slate-300">

        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
          Custom Software
        </div>

        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
          Mobile Applications
        </div>

        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
          Business Systems
        </div>

        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
          Digital Innovation
        </div>

      </div>
    </div>
  </div>

  {/* Slide Indicators */}
  <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
    {heroImages.map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentSlide(index)}
        className={`h-1.5 rounded-full transition-all duration-500 ${
          index === currentSlide
            ? "w-10 bg-white"
            : "w-3 bg-white/40 hover:bg-white/70"
        }`}
        aria-label={`Go to slide ${index + 1}`}
      />
    ))}
  </div>

  {/* Scroll indicator */}
  <div className="hidden md:flex absolute bottom-8 right-10 lg:right-16 z-20 items-center gap-3 text-xs uppercase tracking-[0.2em] text-slate-400">
    Scroll to explore

    <div className="h-10 w-[1px] bg-gradient-to-b from-white/70 to-transparent"></div>
  </div>
</section>

    {/* About Section */}
<section className="relative py-24 px-6 bg-slate-50 overflow-hidden">
  {/* Background decoration */}
  <div className="absolute top-0 left-0 w-[420px] h-[420px] bg-blue-100/60 rounded-full blur-[120px]"></div>
  <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-blue-50 rounded-full blur-[100px]"></div>

  <div className="relative z-10 max-w-7xl mx-auto">
    {/* Content */}
    <div className="max-w-5xl mx-auto">
      {/* Badge */}
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 text-blue-600 text-sm font-semibold mb-6">
        <span className="w-2 h-2 rounded-full bg-blue-600"></span>
        About Nexindi Tech
      </div>

      {/* Heading */}
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight leading-tight mb-6">
        Building technology that
        <span className="text-blue-600"> creates real impact.</span>
      </h2>

      {/* Description */}
      <div className="max-w-4xl">
        <p className="text-lg text-slate-600 leading-relaxed mb-6">
          NEXINDI TECH is a registered technology solutions company focused
          on building innovative digital products that help businesses,
          institutions, and individuals grow in an increasingly digital world.
        </p>

        <p className="text-lg text-slate-600 leading-relaxed mb-10">
          We combine modern software engineering, practical innovation, and
          a deep understanding of local challenges to create solutions that
          are useful, scalable, and built for real-world needs.
        </p>
      </div>

      {/* Highlights */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-7 mb-10 max-w-4xl">
        {[
          {
            title: "Innovation Driven",
            desc: "Modern solutions built around real problems.",
          },
          {
            title: "Africa Focused",
            desc: "Technology designed for local opportunities.",
          },
          {
            title: "Scalable Systems",
            desc: "Products engineered to grow with businesses.",
          },
          {
            title: "Long-Term Impact",
            desc: "Creating value beyond just software delivery.",
          },
        ].map((item, index) => (
          <div key={index} className="flex gap-4">
            <div className="mt-1 flex-shrink-0 w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-blue-600"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>

            <div>
              <h3 className="font-bold text-slate-900 mb-1">
                {item.title}
              </h3>

              <p className="text-sm text-slate-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <a
        href="/about"
        className="group inline-flex items-center gap-3 bg-blue-600 text-white px-7 py-4 rounded-xl font-semibold hover:bg-blue-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-600/20"
      >
        Learn More About Us

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="transition-transform duration-300 group-hover:translate-x-1"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </a>
    </div>
  </div>
</section>

        {/* Services Section */}
<section className="relative py-24 px-6 bg-white overflow-hidden">
  {/* Background decoration */}
  <div className="absolute top-0 right-0 w-[450px] h-[450px] bg-blue-100/60 rounded-full blur-[120px]"></div>

  <div className="absolute bottom-0 left-0 w-[350px] h-[350px] bg-blue-50 rounded-full blur-[100px]"></div>

  <div className="relative z-10 max-w-7xl mx-auto">
    {/* Section Heading */}
    <div className="max-w-3xl mx-auto text-center mb-16">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 text-blue-600 text-sm font-semibold mb-5">
        <span className="w-2 h-2 rounded-full bg-blue-600"></span>
        Industries We Empower
      </div>

      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight mb-6">
        Technology solving
        <span className="text-blue-600"> real-world problems.</span>
      </h2>

      <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
        We design and build digital solutions that help businesses,
        organizations, and communities operate smarter and create greater
        impact.
      </p>
    </div>

    {/* Services Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {[
        {
          title: "Health",
          desc: "Improving access to healthcare through intelligent digital platforms and connected health solutions.",
          icon: FaHeartbeat,
          number: "01",
        },
        {
          title: "Finance",
          desc: "Building secure financial tools that help businesses and individuals manage, transact, and grow.",
          icon: FaMoneyBillWave,
          number: "02",
        },
        {
          title: "Agriculture",
          desc: "Empowering farmers and agribusinesses with technology for smarter decisions and higher productivity.",
          icon: FaSeedling,
          number: "03",
        },
        {
          title: "Education",
          desc: "Creating modern digital platforms that make learning, administration, and access to knowledge easier.",
          icon: FaChalkboardTeacher,
          number: "04",
        },
      ].map((service, index) => {
        const Icon = service.icon;

        return (
          <div
            key={index}
            className="group relative bg-white border border-slate-200 rounded-3xl p-8 overflow-hidden transition-all duration-500 hover:-translate-y-2 hover:border-blue-200 hover:shadow-2xl hover:shadow-blue-900/10"
          >
            {/* Hover background */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-800 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

            {/* Number */}
            <span className="absolute top-6 right-7 text-sm font-bold text-slate-300 group-hover:text-white/40 transition-colors duration-500">
              {service.number}
            </span>

            {/* Content */}
            <div className="relative z-10">
              {/* Icon */}
              <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mb-8 group-hover:bg-white/15 transition-all duration-500">
                <Icon
                  size={26}
                  className="text-blue-600 group-hover:text-white transition-colors duration-500"
                />
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-white transition-colors duration-500">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-slate-600 leading-relaxed group-hover:text-blue-50 transition-colors duration-500">
                {service.desc}
              </p>

              {/* Learn More */}
              <div className="flex items-center gap-2 mt-8 text-blue-600 font-semibold text-sm group-hover:text-white transition-colors duration-500">
                Learn more

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="transition-transform duration-300 group-hover:translate-x-1"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </div>
            </div>

            {/* Decorative circle */}
            <div className="absolute -bottom-20 -right-20 w-40 h-40 rounded-full bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </div>
        );
      })}
    </div>

    {/* Bottom CTA */}
    <div className="mt-14 flex justify-center">
      <a
        href="/services"
        className="inline-flex items-center gap-3 px-7 py-4 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-600/20"
      >
        Explore All Our Services

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </a>
    </div>
  </div>
</section>

        <StatsSection />

        <ClientsSection />

        {/* CTA Section */}
<section className="relative py-24 px-6 bg-white overflow-hidden">

  {/* Background decoration */}
  <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-blue-100/50 rounded-full blur-[120px]" />

  <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-50 rounded-full blur-[120px]" />

  <div className="relative z-10 max-w-7xl mx-auto">

    {/* Main CTA Container */}
    <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-blue-600 via-blue-700 to-slate-950 px-6 py-16 md:px-14 md:py-20 lg:px-20 lg:py-24">

      {/* Background Grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.7) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.7) 1px, transparent 1px)
          `,
          backgroundSize: "50px 50px",
        }}
      />

      {/* Glow Effects */}
      <div className="absolute -top-40 -right-20 w-[500px] h-[500px] bg-cyan-400/20 rounded-full blur-[140px]" />

      <div className="absolute -bottom-40 -left-20 w-[450px] h-[450px] bg-blue-400/20 rounded-full blur-[130px]" />

      {/* Decorative circle */}
      <div className="absolute top-10 right-10 w-40 h-40 border border-white/10 rounded-full hidden lg:block" />

      <div className="absolute top-20 right-20 w-20 h-20 border border-white/10 rounded-full hidden lg:block" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-md text-blue-100 text-sm font-semibold mb-7">
          <span className="relative flex w-2 h-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-300 opacity-75 animate-ping" />
            <span className="relative inline-flex rounded-full w-2 h-2 bg-cyan-300" />
          </span>

          Let's Build Something Great
        </div>

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
          Have an idea?
          <span className="block text-blue-200">
            Let's turn it into technology.
          </span>
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-blue-100/90 leading-relaxed max-w-2xl mx-auto mb-10">
          Whether you're a startup, business, institution, or organization,
          Nexindi Tech can help you design and build digital solutions that
          solve real problems and create lasting value.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">

          {/* Primary CTA */}
          <a
            href="/contact"
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-white text-blue-700 px-8 py-4 rounded-xl font-bold hover:bg-blue-50 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-black/20"
          >
            Start a Project

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="transition-transform duration-300 group-hover:translate-x-1"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </a>

          {/* Secondary CTA */}
          <a
            href="/services"
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 border border-white/30 bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-xl font-semibold hover:bg-white/20 hover:border-white/40 transition-all duration-300"
          >
            Explore Our Services
          </a>

        </div>

        {/* Trust Message */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-blue-200">

          <span className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-cyan-300"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>

            Custom Solutions
          </span>

          <span className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-cyan-300"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>

            Modern Technology
          </span>

          <span className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-cyan-300"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>

            Built for Growth
          </span>

        </div>
      </div>
    </div>
  </div>
</section>
      </div>

      {/* Floating WhatsApp Button */}
      <WhatsAppButton />
    </>
  );
}

export default App;